import { render } from "./App.vue?vue&type=template&id=33acc728"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=33acc728&lang=less"

import exportComponent from "/Users/dinghuaiqiang/gitee/lavenir-reed-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__